import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTree = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 -32 448 576",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M224.5-32c7 0 13.7 3.1 18.3 8.5l136 160c6.1 7.1 7.4 17.1 3.5 25.6-3.9 8.5-12.4 13.9-21.8 13.9l-24.9 0 75.2 88.5c6.1 7.1 7.4 17.1 3.5 25.6S401.8 304 392.5 304l-38.5 0 88.8 104.5c6.1 7.1 7.4 17.1 3.5 25.6S433.8 448 424.5 448l-176 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-176 0c-9.4 0-17.9-5.4-21.8-13.9S.2 415.6 6.2 408.5L95 304 56.5 304c-9.4 0-17.9-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l75.2-88.5-24.9 0c-9.4 0-17.9-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l136-160 1.8-1.9c4.4-4.2 10.3-6.6 16.5-6.6zM140.4 128l24.9 0c9.3 0 17.9 5.5 21.8 13.9s2.5 18.5-3.5 25.6l-75.2 88.5 38.5 0c9.3 0 17.9 5.4 21.8 13.9s2.5 18.5-3.5 25.6L76.4 400 372.6 400 283.8 295.5c-6.1-7.1-7.4-17.1-3.5-25.6S292.7 256 302.1 256l38.5 0-75.2-88.5c-6-7.1-7.4-17.1-3.5-25.6S274.3 128 283.7 128l24.9 0-84.1-99-84.1 99z"
		})
	});
};
export default SvgTree;
